import { ReactComponent as PlantIcon } from './plant.svg';

export default PlantIcon;
